import { colorStrings } from "@iewcasia/Utilities/variables";
import { teamCardWidgetStyles as styles } from "@iewcasia/Widgets/VerndaleBox/TeamCardWidget";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.wrapper = {
    css: css`
        border: 1px solid ${getColor(colorStrings.commonBorder)};
        height: 100%;

        &.team-card__wrapper--with-hover {
            &:hover {
                box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.15);
                cursor: pointer;
            }
        }
    `,
};

styles.thumbnail = {
    css: css`
        aspect-ratio: 1;
        text-align: center;
        padding: 10px;
    `,
};

styles.textWrapper = {
    css: css`
        padding: 10px;
    `,
};

styles.name = {
    variant: "h5",
    forwardAs: "h3",
};

styles.title = {
    variant: "body",
    forwardAs: "span",
};
